<style lang="less" scoped>
.fill{
  width: 100%;
  height: 100%;
}
.app-wrapper {
  widows: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.sidebar-container {
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  background-color: #001529;
  border-right: none;
}

.app-el-main {
  padding: 0;
}
.main-container {
  background-color: #f0f2f5;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.copyright {
  margin-top: 20px;
  background-color: #f0f2f5;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 18px 0;
  svg {
    margin: 0 3px;
  }
}
</style>

<template>
  <div class="fill">
    <el-container :class="classObj" v-if="useLayout">
      <sidebar class="sidebar-container" />
      <el-main class="app-el-main">
        <div class="main-container">
          <navbar />
          <app-main />
          <div class="copyright">
            <span><a style="color: rgba(0, 0, 0, 0.45); margin-right: 5px" href="http://www.beian.miit.gov.cn/">沪ICP备 14020594号-5</a></span>
            <span>Copyright</span>
            <icon name="copyright" />
            2018
            <span>北京兴长信达科技发展有限公司长沙分部出品</span>
          </div>
        </div>
      </el-main>
    </el-container>
    <router-view v-else />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  data() {
    return {
      useLayout: true
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        'app-wrapper': true
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    setUseLayout() {
      this.useLayout = this.$route.meta.useLayout !== false
    }
  },
  created() {
    this.setUseLayout()
  },
  watch: {
    $route() {
      this.setUseLayout()
    }
  }
}
</script>
